module.exports = __webpack_public_path__ + "static/media/pla_loa_sta.b3c89ebc.png";